var map = {
	"./posts_en.json": 9393,
	"./posts_en_raw.json": 4904,
	"./posts_id.json": 6211,
	"./posts_id_raw.json": 4686,
	"./posts_nl.json": 3860,
	"./posts_nl_raw.json": 6705,
	"./posts_raw.json": 4080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6881;